/**
 * The 2025 book, as it went off — transcribed from the group-thread post,
 * pasted in by Scott on 2026-08-19.
 *
 * A static fact, not live data: last year's prices are history and never
 * change, so they live here the way the scorecards do, with their provenance,
 * rather than in the document. The odds board shows a man's 2025 price as a
 * data point beside this year's line — the argument "he was +650 last year"
 * settles faster when the number is on the screen.
 *
 * Priced in 2025 but not in this year's field, kept for the record:
 * Michael Blackham (+200), Dave Nixon (+1000), Eric Towner (+2000).
 * Tyler made the 2025 book and, as bookie, carried no line on himself.
 */
export const ODDS_2025: Record<string, number> = {
  poulton: 400, // Jeff Poulton
  phil: 650, // Phil Dance
  thomas: 750, // Thomas Godfrey
  danny: 750, // Danny Mckean
  scottp: 900, // Scott Perucca
  cramer: 1500, // Scott Cramer
  wittwer: 2000, // Josh Wittwer
  springer: 2200, // Josh Springer
}
